import type { ConnectError } from '@connectrpc/connect'
import {
  DemandBreakdownSaveErrorReason,
  DemandBreakdownSaveErrorReasonSchema,
} from '@ebalance/proto/bffuser/v1/demand_breakdown_mode_model_pb'
import type { TFunction } from 'i18next'

import {
  type AppErrorInfoReasonEntry,
  type AppErrorInfoResolution,
  resolveAppErrorInfoMessage,
} from '~/libs/appErrorInfo'

/**
 * 想定モードの保存の拒否理由 → 文言。どちらも 1 つの入力欄に帰属しないので、モーダル上部に出す。
 */
const BREAKDOWN_SAVE_REASON_KEYS: Record<
  DemandBreakdownSaveErrorReason,
  AppErrorInfoReasonEntry | undefined
> = {
  [DemandBreakdownSaveErrorReason.UNSPECIFIED]: undefined,
  [DemandBreakdownSaveErrorReason.BY_GROUP_WITHOUT_DEMAND_GROUPS]: {
    key: 'page:demandSettings.serverError.reason.byGroupWithoutDemandGroups',
  },
  [DemandBreakdownSaveErrorReason.RETAILER_OUT_OF_SCOPE]: {
    key: 'page:demandSettings.serverError.reason.retailerOutOfScope',
  },
}

/** 想定モード設定モーダルの `useCrudModalForm` に渡す `resolveDetailedError`。 */
export function resolveBreakdownSaveDetailedError(
  err: ConnectError,
  t: TFunction,
): AppErrorInfoResolution | undefined {
  return resolveAppErrorInfoMessage(
    err,
    DemandBreakdownSaveErrorReasonSchema,
    BREAKDOWN_SAVE_REASON_KEYS,
    t,
  )
}
